<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { VueContentLoading } from "vue-content-loading";
import { mapActions, mapGetters } from "vuex";
// import Ststistic from '../../../model/ststistic.js';

export default {
  page: {
    title: "الاحصائيات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueContentLoading },
  data() {
    return {
      title: "احصائيات عامة",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "الاحصائيات",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      // showAdminStstistic: false,
      // showPostStstistic: false,
      // showLinkStstistic: false,
      // showAttachmentStstistic: false,
      // showImageStstistic: false,
      // showVideoStstistic: false,
      showStstistic: false,

      // ststistic: new Ststistic,
      loadingContent: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    // ...mapGetters('ststistic', ['getStstistic'])
  },
  methods: {
    ...mapActions("auth", ["hasAllPermission"]),
    // ...mapActions("ststistic", ['getAll']),
    handleError(error) {
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
  },
  created() {
    // this.showAdminStstistic  = this.getUser.hasPermission('show_admin_ststistic');
    // this.showPostStstistic  = this.getUser.hasPermission('show_post_ststistic');
    // this.showLinkStstistic  = this.getUser.hasPermission('show_link_ststistic');
    // this.showAttachmentStstistic  = this.getUser.hasPermission('show_attachment_ststistic');
    // this.showImageStstistic  = this.getUser.hasPermission('show_image_ststistic');
    // this.showVideoStstistic  = this.getUser.hasPermission('show_video_ststistic');

    // this.showStstistic = this.showAdminStstistic || this.showPostStstistic || this.showLinkStstistic ||
    //  this.showAttachmentStstistic || this.showImageStstistic || this.showVideoStstistic;

    // if(this.showStstistic)
    //   this.getAll()
    //   .then(()=>{
    //     this.ststistic = this.getStstistic
    //     this.loadingContent = true
    //   })
    // else
    this.loadingContent = true;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div v-if="loadingContent">
      <div class="row" v-if="showStstistic">
        <!-- <div class="col-md-4 col-sm-6" v-if="showPostStstistic">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">الاخبار</h4>
              
              <apexchart
                class="apex-charts"
                dir="rtl"
                height="303"
                type="donut"
                :series="ststistic.charts.post.series"
                :options="ststistic.charts.post.chartOptions"
              ></apexchart>
              
              <div class="text-center text-muted">
                <div class="row">
                  <div class="col-4" v-for="(item, i) in ststistic.charts.post.list.labels" :key="item">
                    <div class="mt-2">
                      <p class="mb-1 text-truncate">
                        <i :class="'mdi mdi-circle text-'+ststistic.charts.post.list.colors[i]+' mr-1'"></i>
                        {{item}}
                      </p>
                      <h5>{{ ststistic.charts.post.list.count[i] }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="col-md-4 col-sm-6" v-if="showImageStstistic">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">البوم الصور</h4>
        
              <apexchart
                class="apex-charts"
                height="303"
                type="pie"
                dir="ltr"
                :series="ststistic.charts.image.series"
                :options="ststistic.charts.image.chartOptions"
              ></apexchart>

              <div class="text-center text-muted">
                <div class="row">
                  <div class="col-3" v-for="(item, i) in ststistic.charts.image.list.labels" :key="item">
                    <div class="mt-2">
                      <p class="mb-1 text-truncate">
                        <i :class="'mdi mdi-circle text-'+ststistic.charts.image.list.colors[i]+' mr-1'"></i>
                        {{item}} 
                      </p>
                      <h5>{{ ststistic.charts.image.list.count[i] }}</h5>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div> -->

        <!-- <div class="col-md-4 col-sm-12">
          <div class="row">
            <div class="col-md-12" v-if="showLinkStstistic">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="mr-3">
                      <p class="text-muted mb-2">عدد الخدمات</p>
                      <h5 class="mb-0">{{ststistic.links}}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-shape-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="showVideoStstistic">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="mr-3">
                      <p class="text-muted mb-2">عدد الفيديوهات</p>
                      <h5 class="mb-0">{{ststistic.videos}}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bxs-videos"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="showAttachmentStstistic">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="mr-3">
                      <p class="text-muted mb-2">عدد المستندات</p>
                      <h5 class="mb-0">{{ststistic.attachments}}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bxs-file-doc"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="showAdminStstistic">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="mr-3">
                      <p class="text-muted mb-2">عدد المدراء</p>
                      <h5 class="mb-0">{{ststistic.admins}}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bxs-user-detail"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <div v-else>
        <h1>مركز العمل التطوعي</h1>
      </div>
    </div>

    <!-- loading content -->
    <div v-else>
      <vue-content-loading :rtl="true" :width="400" :height="110">
        <rect x="0" y="0" rx="1" ry="1" width="129" height="100" />
        <rect x="136" y="0" rx="1" ry="1" width="129" height="100" />
        <rect x="272" y="0" rx="1" ry="1" width="129" height="22" />
        <rect x="272" y="26" rx="1" ry="1" width="129" height="22" />
        <rect x="272" y="52" rx="1" ry="1" width="129" height="22" />
        <rect x="272" y="78" rx="1" ry="1" width="129" height="22" />
      </vue-content-loading>
    </div>
  </Layout>
</template>
